import { createClient } from '@sanity/client';

const projectId = (process.env.REACT_APP_SANITY_PROJECT_ID || 'bkqwin2g').trim();
const dataset = (process.env.REACT_APP_SANITY_DATASET || 'production').trim();

export default createClient({
    projectId,
    dataset,
    apiVersion: '2022-03-07',
    useCdn: true,
});
